import ApiService from "./ApiService";
import axios from "axios";
import appConfig from "configs/app.config";
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from "constants/api.constant";

export async function apiSignIn(data) {
  return ApiService.fetchData({
    url: `User/Login?email=${encodeURIComponent(data.email)}&password=${encodeURIComponent(data.password)}`,
    method: "post",
  });
}
export async function apiSignUp(data) {
  return ApiService.fetchData({
    url: "User/Register?",
    method: "post",
    data,
  });
}
export async function apiGetForgotPassword(data) {
  return ApiService.fetchData({
    url: `User/ForgotPassword?email=${data}`,
    method: "get",
  });
}
export async function apiPostForgotPassword(data) {
  return ApiService.fetchData({
    url: "User/ForgotPassword",
    method: "post",
    data,
  });
}

export async function apiCheckUserPhone(data) {
  return ApiService.fetchData({
    url: `User/CheckUserPhone?phone=${encodeURIComponent(data)}`,
    method: "get",
  });
}

export async function apiSendCodeByPhone(data) {
  return ApiService.fetchData({
    url: `User/SendCodeByPhone?phone=${encodeURIComponent(data)}`,
    method: "get",
  });
}

export async function apiSimpleRegister(data) {
  return ApiService.fetchData({
    url: `User/SimpleRegister?phone=${encodeURIComponent(
      data.phone,
    )}&email=${encodeURIComponent(data.email)}`,
    method: "get",
  });
}

export async function apiCodeCheckBySms(data) {
  return ApiService.fetchData({
    url: `User/CodeCheckBySms`,
    method: "post",
    data,
  });
}

export async function apiUpdateEmail({ email, token }) {
  return axios({
    url: `${appConfig.apiPrefix.replace(/\/?$/, "/")}User/UpdateEmail`,
    method: "post",
    data: { email },
    headers: {
      [REQUEST_HEADER_AUTH_KEY]: `${TOKEN_TYPE}${token}`,
      "Content-Type": "application/json",
    },
  });
}
